import React, {
  forwardRef,
  useRef,
  useImperativeHandle} from "react";
import Button from "@mui/material/Button";
import {FormButtonStyle} from "./FormButtonStyle";

interface ButtonInputProps {
  id?: string;
  type?: "submit" | "reset" | "button" | undefined;
  size?: "small" | "medium" | "large" | undefined;
  fullWidth?: boolean;
  variant?: "contained" | "outlined" | "text" | undefined;
  onClick?: () => void;
  outlet: string;
  autoFocus?: boolean;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  styles?: React.CSSProperties | undefined;
  form?: string;
  name?: string;
}

const formButton = forwardRef(({
  type,
  size,
  variant,
  fullWidth,
  outlet,
  onClick,
  autoFocus,
  disabled,
  startIcon,
  endIcon,
  styles,
  form,
  name,
}: ButtonInputProps, ref) => {
  const refButton = useRef<HTMLButtonElement>(null);

  useImperativeHandle(ref, () => ({
    focusButton() {
      if(refButton?.current)
      {
        const button = refButton?.current;
        button.focus();
      }
    }
  }));

  return (
    <>
      <Button
        ref={refButton}
        name={name}
        type={type}
        size={size}
        variant={variant}
        sx={{...FormButtonStyle.buttonStyle, ...styles}}
        fullWidth={fullWidth}
        onClick={onClick}
        autoFocus={autoFocus}
        startIcon={startIcon}
        endIcon={endIcon}
        disabled={disabled}
        form={form}>
        {outlet}
      </Button>
    </>
  );
});

formButton.displayName = "FormButton";
export const FormButton = formButton;
